function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.cartDrawer = document.querySelector('cart-drawer');
    this.cartUpsellBar = document.querySelector('.cart-upsell-bar');

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    // don't fire the on cart note change here, since that's being handled separately
    if (event.target != document.getElementById('Cart-note')) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
  }

  /**
   * addFreeProductToCart
   * @description Add the free product to the cart if its set
   */
   addFreeProductToCart() {
    this.freeProduct = document.querySelector('[data-free-gift]');

    // Return when there is no freeProduct set or found.
    if(!this.freeProduct?.dataset?.freeGiftId) {
      return;
    }

    this.freeProductVariantId = parseInt(this.freeProduct.dataset.freeGiftId);

    const body = JSON.stringify({
      items: [
        {
          id: this.freeProductVariantId,
          quantity: 1
        }
      ],
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    return fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
    .then(response => response.json())
    .then((data) => {
      this.refreshInterface();
      this.cartDrawer.renderContents(data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  /**
   * refreshInterface
   * @description Update the interface with a section api request to multiple sections to render
   * @param {Object} parsedState
   */
  refreshInterface() {
    // Collect sections that we will use for the section api render..
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    return fetch(`${routes.cart_url}`, { ...fetchConfig(), ...{ body }})
      .then(response => response.json())
      .then(data => {
        document.querySelectorAll('.cart-icon-bubble__count span').forEach((elem) => {
          elem.innerHTML = data.item_count
        });
      });
  }

  /**
   * getSectionsToRender
   * @returns {Array}
   */
  getSectionsToRender() {
    const sectionsToRender = [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-cart-item-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-cart-footer-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
      {
        id: 'cart-drawer-icon-bubble',
        section: 'cart-drawer-icon-bubble',
        selector: '[data-cart-drawer-icon-bubble]',
      }
    ]

    if (this.cartUpsellBar) {
      const upsellBarSection = {
        id: 'main-cart-upsell-bar',
        section: document.getElementById('main-cart-upsell-bar').dataset.id,
        selector: '.js-cart-upsell-bar-contents',
      }
      sectionsToRender.push(upsellBarSection);
    }

    return sectionsToRender;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}.js`, { ...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.json();
      })
      .then((parsedState) => {
        if (document.querySelector('[data-free-gift]')) {
          return (async () => {
            this.addFreeProductToCart();
            return parsedState;
          })();
        }
        else {
          return parsedState;
        }
      })
      .then((parsedState) => {
        this.classList.toggle(
          parsedState.sections["cart-drawer"] ? "cart-drawer-is-empty" : "is-empty",
          parsedState.item_count === 0
        );

        document.getElementById("main-cart-footer")?.classList.toggle("is-empty", parsedState.item_count === 0);

        // Reload if we are on the cart page
        if (window.location.pathname === '/cart') {
          window.location.reload();
        }

        this.getSectionsToRender().forEach((section) => {
          if (document.getElementById(section.id)) {
            const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        document.querySelectorAll('.cart-icon-bubble__count span').forEach((elem) => {
          elem.innerHTML = parsedState.item_count;
        });

        this.updateLiveRegions(line, quantity);
        document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${name}"]`)?.focus();
        this.disableLoading();
      })
      .catch((error) => {
        console.log(error);
        document.querySelector(".loading-overlay").classList.add("hidden");
        document.getElementById("cart-errors").textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateCart(parsedState, line) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));

    this.updateLiveRegions(line, parsedState.item_count);
    document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${name}"]`)?.focus();
    this.disableLoading();
  }

  // show error texts, should not be deleted.
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      if (document.getElementById(`Line-item-error-${line}`)?.querySelector('[data-cart-item-error-text]')) {
        document.getElementById(`Line-item-error-${line}`)
          .querySelector('[data-cart-item-error-text]')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          );
      }
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus?.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus?.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    document.querySelector('.loading-overlay').classList.remove('hidden');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

if (!customElements.get('cart-items')) {
  customElements.define('cart-items', CartItems);
}
